import { render, staticRenderFns } from "./GalleriesCard.vue?vue&type=template&id=a7abd6d4&scoped=true&"
import script from "./GalleriesCard.vue?vue&type=script&lang=js&"
export * from "./GalleriesCard.vue?vue&type=script&lang=js&"
import style0 from "./GalleriesCard.vue?vue&type=style&index=0&id=a7abd6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7abd6d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
